import {usePage} from "@inertiajs/vue3";
import {computed} from "vue";
import {User} from "@/types";

const page = usePage()

const user = computed<User>(() => {
    return page.props.user as User
})

export const useAuth = () => {
    return {
        user
    }
}
